import React, { useState } from "react";
import { useEffect } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import  './Resources/Actions.css';
import './App.css';

export default function Dailycollection(){

    const[dlist,setDlist] = useState([]);
    const[date, setDate] = useState(new Date().toISOString().slice(0,10));
    const[enddate,setEnddate]= useState(new Date().toISOString().slice(0,10));

    const [userid,setUserid] =useState( parseInt(localStorage.getItem("userid")) );
    const user = parseInt(localStorage.getItem("utype"));
    
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_WEB_API_KEY;

    const [checked, setChecked] = useState(false);
    const [overduechecked, setOverduechecked] = useState(false);
    var i = 0;
    
    useEffect(()=>{
    if(user === 1) 
    {
        if(checked === false)
        { 
            fetch(API_URL+"api/Payment/GetDailyCollection?startdate="+date +"&enddate="+enddate)
            .then(response => response.json())
            .then(data => {setDlist(data)})
        }
        else
        {
            fetch(API_URL+"api/Payment/GetDailyCollectionByUser?rdate="+date +"&edate="+enddate+"&userid="+userid)
            .then(response => response.json())
            .then(data => {setDlist(data)})
        }
    }
    else
    { 
            fetch(API_URL+"api/Payment/GetDailyCollectionByUser?rdate="+date +"&edate="+date+"&userid="+userid)
        .then(response => response.json())
        .then(data => {setDlist(data)})
    }
    },[date,enddate,userid,checked,overduechecked]);

    function handleClick() {
        
        setOverduechecked(!checked);
      };

    console.log(overduechecked);
    
    const Total = dlist.length > 0 ? dlist.reduce((tot,el)=>tot+ el.RAmount,0 ): 0;
    const fTotal = dlist.length > 0 ? dlist.reduce((tot,el)=>tot+ el.RFine,0 ): 0;
    const OverdueTotal = dlist.length > 0 ? dlist.reduce((tot,el)=>tot+ el.OverDue,0 ): 0;

    console.log(userid);
    
    return(
        <>
        <div className="reportheader"> 
            Collection Report
            <Navbar/>
        </div>      

       <div style={{backgroundColor:"lightskyblue",padding:"10px"}}>

        {user !== 1 ? <> 
        <label for="sdate" style={{marginTop:"10px"}}>Start Date</label>
        <input id="sdate" type="date" defaultValue={date} style={{height:"25px",width:"150px",marginTop:"5px",marginLeft:"15px"}} onChange={(e)=>{setDate(e.target.value)}} ></input>
        <label><input type="checkbox" id='overdue' style={{height:"18px",width:"18px",marginTop:"10px"}} onClick={()=>{setOverduechecked(!overduechecked) }}/>OverDue</label><br/></>
         :
         <>
        <label for="sdate" style={{marginTop:"10px"}}>Start Date</label>
        <input id="sdate" type="date" defaultValue={date} style={{height:"25px",width:"150px",marginTop:"5px",marginLeft:"15px"}} onChange={(e)=>{setDate(e.target.value)}} ></input><br/>
       
        <label for="ldate" style={{marginTop:"10px"}}>End Date</label>
        <input id="ldate" type="date" defaultValue={enddate} style={{height:"25px",width:"150px",marginTop:"5px",marginLeft:"20px"}} onChange={(e)=>{setEnddate(e.target.value)}} ></input>
        <label><input type="checkbox" id='overdue'  style={{height:"18px",width:"18px",marginTop:"10px"}} onClick={()=>{setOverduechecked(!overduechecked)}}/>OverDue</label><br/></>}
 
        {user === 1 ? <>
        <label><input type="checkbox" id='byuser' style={{height:"18px",width:"18px"}} onChange={(e)=>{setChecked(!checked); checked ? document.getElementById('userid').disabled = true : document.getElementById('userid').disabled = false}}/>By</label><br/>
        <label for="userid" style={{marginTop:"10px",marginLeft:"5px"}}>UserID</label>

        <input id="userid" style={{height:"25px",width:"150px",marginTop:"5px",marginLeft:"30px"}} onChange={(e)=>{if(e.target.value !== ''){setUserid(e.target.value)}}} disabled></input>
        </> : <></>}

        </div> 
        
        <table style={{width:"97.5%",marginTop:"20px",backgroundColor:"lightskyblue",marginBottom:"40px"}}>
 
            {overduechecked !== true ? <>
            <tr>
                <th>S.no</th>
                <th>L.No</th>
                <th>R.No</th>
                <th>CusName</th>
                <th>Fine</th>
                <th>Paid</th>
            </tr>
        {dlist.length > 0 ? <>
        {dlist.map(loan =>{return(<tr>
            <td>{++i}</td>
            <td style={{textAlign:"center"}}>{loan.AccountNo}</td>
            <td style={{textAlign:"center"}}>{loan.ReceiptNo}</td>
            <td style={{textAlign:"left"}}>{loan.CustomerName}</td>
            <td>{loan.RFine}</td>
            <td>{loan.RAmount}</td>
        </tr>)})}
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td style ={{fontWeight:"bolder"}}>{fTotal}</td>
            <td style ={{fontWeight:"bolder"}}>{Total}</td>
        </tr>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td style ={{fontWeight:"bolder"}}> Total</td>
            <td style ={{fontWeight:"bolder"}}>{Total + fTotal}</td>
        </tr></> : <></>} </> 
        :<>
        <tr>
                <th>S.no</th>
                <th>L.No</th>
                <th>R.No</th>
                <th>CusName</th>
                <th>OverDue</th>
            </tr>
        {dlist.length > 0 ? <>
        {dlist.map(loan =>{if(loan.OverDue > 0) {return(<tr>
            <td>{++i}</td>
            <td style={{textAlign:"center"}}>{loan.AccountNo}</td>
            <td style={{textAlign:"center"}}>{loan.ReceiptNo}</td>
            <td style={{textAlign:"left"}}>{loan.CustomerName}</td>
            <td>{loan.OverDue}</td>
        </tr>)}})}
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td>Total</td>
            <td style ={{fontWeight:"bolder"}}>{OverdueTotal}</td>
        </tr>
        </> : <></>}</>}
        </table> 
        <button type="button" className="backbutton" onClick={()=>{navigate('/loandetails')}}>Back</button>
        </>
    )        
        
        
}